import createIcon from '../../createIcon';

/**
 * @component @name CellTower
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy4zIDE0LjI1MDJMOC41IDEzLjA1MDJDNy41IDEyLjA1MDIgNyAxMC43NTAyIDcgOS41NTAyQzcgOC4yNTAyIDcuNSA2Ljk1MDIgOC41IDYuMDUwMkw3LjMgNC44NTAyQzYgNi4xNTAyIDUuMyA3Ljg1MDE5IDUuMyA5LjU1MDJDNS4zIDExLjI1MDIgNiAxMi45NTAyIDcuMyAxNC4yNTAyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE5LjEgMi40NTAyTDE3LjkgMy42NTAyQzE5LjUgNS4yNTAyIDIwLjMgNy40NTAyIDIwLjMgOS41NTAyQzIwLjMgMTEuNjUwMiAxOS41IDEzLjg1MDIgMTcuOSAxNS40NTAyTDE5LjEgMTYuNjUwMkMyMS4xIDE0LjY1MDIgMjIgMTIuMTUwMiAyMiA5LjU1MDJDMjIgNi45NTAyIDIxIDQuNDUwMiAxOS4xIDIuNDUwMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik02LjEgMy42NTAyTDQuOSAyLjQ1MDJDMyA0LjQ1MDIgMiA2Ljk1MDIgMiA5LjU1MDJDMiAxMi4xNTAyIDMgMTQuNjUwMiA0LjkgMTYuNjUwMkw2LjEgMTUuNDUwMkM0LjUgMTMuODUwMiAzLjcgMTEuNjUwMiAzLjcgOS41NTAyQzMuNyA3LjQ1MDIgNC41IDUuMjUwMiA2LjEgMy42NTAyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2LjcgMTQuMjUwMkMxOCAxMi45NTAyIDE4LjcgMTEuMjUwMiAxOC43IDkuNTUwMkMxOC42IDcuODUwMTkgMTggNi4xNTAyIDE2LjcgNC44NTAyTDE1LjUgNi4wNTAyQzE2LjUgNy4wNTAyIDE3IDguMzUwMTkgMTcgOS41NTAyQzE3IDEwLjg1MDIgMTYuNSAxMi4xNTAyIDE1LjUgMTMuMDUwMkwxNi43IDE0LjI1MDJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTQuNSA5LjU1MDJDMTQuNSA4LjE3MDIgMTMuMzggNy4wNTAyIDEyIDcuMDUwMkMxMC42MiA3LjA1MDIgOS41IDguMTcwMiA5LjUgOS41NTAyQzkuNSAxMC4zMTAyIDkuODQgMTAuOTcwMiAxMC4zNyAxMS40MzAyTDcgMjEuNTUwMkg5TDkuNjcgMTkuNTUwMkgxNC4zNEwxNSAyMS41NTAySDE3TDEzLjYzIDExLjQzMDJDMTQuMTYgMTAuOTcwMiAxNC41IDEwLjMxMDIgMTQuNSA5LjU1MDJaTTEwLjMzIDE3LjU1MDJMMTIgMTIuNTUwMkwxMy42NyAxNy41NTAySDEwLjMzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CellTower = createIcon('CellTower', [
  [
    'path',
    {
      d: 'M7.3 14.2502L8.5 13.0502C7.5 12.0502 7 10.7502 7 9.5502C7 8.2502 7.5 6.9502 8.5 6.0502L7.3 4.8502C6 6.1502 5.3 7.85019 5.3 9.5502C5.3 11.2502 6 12.9502 7.3 14.2502Z',
      key: 'wkuaf1',
    },
  ],
  [
    'path',
    {
      d: 'M19.1 2.4502L17.9 3.6502C19.5 5.2502 20.3 7.4502 20.3 9.5502C20.3 11.6502 19.5 13.8502 17.9 15.4502L19.1 16.6502C21.1 14.6502 22 12.1502 22 9.5502C22 6.9502 21 4.4502 19.1 2.4502Z',
      key: '19dt3r',
    },
  ],
  [
    'path',
    {
      d: 'M6.1 3.6502L4.9 2.4502C3 4.4502 2 6.9502 2 9.5502C2 12.1502 3 14.6502 4.9 16.6502L6.1 15.4502C4.5 13.8502 3.7 11.6502 3.7 9.5502C3.7 7.4502 4.5 5.2502 6.1 3.6502Z',
      key: 'ayp5iy',
    },
  ],
  [
    'path',
    {
      d: 'M16.7 14.2502C18 12.9502 18.7 11.2502 18.7 9.5502C18.6 7.85019 18 6.1502 16.7 4.8502L15.5 6.0502C16.5 7.0502 17 8.35019 17 9.5502C17 10.8502 16.5 12.1502 15.5 13.0502L16.7 14.2502Z',
      key: '1kc69n',
    },
  ],
  [
    'path',
    {
      d: 'M14.5 9.5502C14.5 8.1702 13.38 7.0502 12 7.0502C10.62 7.0502 9.5 8.1702 9.5 9.5502C9.5 10.3102 9.84 10.9702 10.37 11.4302L7 21.5502H9L9.67 19.5502H14.34L15 21.5502H17L13.63 11.4302C14.16 10.9702 14.5 10.3102 14.5 9.5502ZM10.33 17.5502L12 12.5502L13.67 17.5502H10.33Z',
      key: '1f46i8',
    },
  ],
]);

export default CellTower;
